import { HtmlPageMetaContextProps } from '~/components/HtmlPageMeta/HtmlPageMetaContextProps'
import { UserApplicationPublicDto } from '~/modules/Auth/Application/GetUser/UserApplicationDto'
import { ProfileDto } from '~/modules/Profile/ProfileDto'
import { ComponentProductDto } from '~/modules/Products/Infrastructure/Dtos/ComponentProductDto'

export interface UserGalleryPageRouteProps {
  user: UserApplicationPublicDto
  profile: ProfileDto
  products: Array<ComponentProductDto>
  htmlPageMetaContextProps: HtmlPageMetaContextProps
}

export type UserGalleryPageViewModel = UserGalleryPageRouteProps

export function fromUserGalleryPagePropsToViewModel (props: UserGalleryPageRouteProps): UserGalleryPageViewModel {
  return {
    user: props.user,
    profile: props.profile,
    products: props.products,
    htmlPageMetaContextProps: props.htmlPageMetaContextProps,
  }
}
